"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPGRADED_USER_EVENT = void 0;
const UPGRADED_USER_EVENT = exports.UPGRADED_USER_EVENT = 'userUpgraded';
